<template>
  <div class="listContainer">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>项目中心</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a @click="showInUserList">公寓服务</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section v-show="!hideIsWorker && !hideInUserEdit && !hideInAddShow">
      <section class="searchBox">
        <span class="addStyle">
          <a-button @click="cleanSystem" style="margin-right:20px;"
            >保洁系统入口</a-button
          >
          <a-button
            type="primary"
            icon="plus"
            @click="hideInAddShow = !hideInAddShow"
            >增加</a-button
          >
        </span>
        <span class="searchStyle">
          <a-input
            v-model="nameSearch"
            style="margin-right:20px;"
            placeholder="请输入项目名称"
          />
          <a-button @click="onReset" style="margin-right:10px">重置</a-button>
          <a-button type="primary" icon="search" @click="onSearch"
            >搜索</a-button
          >
        </span>
      </section>
      <!-- 增加&搜索 end-->
      <section class="tableStyles">
        <table>
          <thead>
            <tr>
              <th v-for="item in thList" :key="item">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data == ''">
              <td></td>
              <td>暂无</td>
              <td></td>
              <td></td>
            </tr>
            <tr v-show="data.length > 0" v-for="(item, i) in data" :key="i">
              <td>{{ item.project_name }}</td>
              <td>{{ item.create_time.substring(0, 10) }}</td>
              <td>{{ item.update_time.substring(0, 10) }}</td>
              <td class="operation">
                <a @click="detailPage(item)">详情</a>
                <a style="color:#67c23a" @click="edit(item)">编辑</a>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>
    <!-- 编辑 -->
    <cleanEdit
      v-show="hideInUserEdit"
      :editDetail="editDetail"
      v-on:hideInEdit="hideInEdit"
    />
    <!-- 编辑 end-->
    <addClean v-if="hideInAddShow" v-on:hideInAdd="hideInAdd" />
    <!-- 详情 -->
    <clearDetail v-show="hideIsWorker" :detail="detail" />
    <!-- 详情 end -->
  </div>
</template>
<script>
import axios from "axios";
import addClean from "@/components/business/addClean"; //新增保洁
import cleanEdit from "@/components/business/cleanEdit"; //编辑保洁
import clearDetail from "@/components/business/clearDetail"; //员工
export default {
  components: {
    cleanEdit,
    addClean,
    clearDetail
  },
  data() {
    return {
      data: {},
      loading: false,
      page: 1,
      pagination: {},
      hideInAddShow: false,
      query_field: "",
      hideInUserEdit: false,
      editDetail: {},
      totalPage: Number,
      nameSearch: "",
      thList: ["项目名称", "创建时间", "修改时间", "操作"],
      hideIsWorker: false,
      detail: {}
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  mounted() {
    this.getData(); //获取列表
  },
  methods: {
    onReset() {
      this.nameSearch = "";
      this.page = 1;
      this.getData();
    },
    cleanSystem() {
      let routeUrl = this.$router.resolve({
        path: "/clean/cleanHouse"
      });
      window.open(routeUrl.href, "_blank");
    },
    onChange(pageNumber) {
      console.log("Page: ", pageNumber);
      this.page = pageNumber;
      this.getData();
    },
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    hideInAdd(msg) {
      this.hideInAddShow = msg;
      this.reload();
    },
    hideInEdit(msg) {
      this.hideInUserEdit = msg;
      this.reload();
    },
    showInUserList() {
      this.hideIsWorker = false;
      this.hideInUserEdit = false;
      this.hideInAddShow = false;
    },
    onSearch(value) {
      this.page = 1;
      // this.query_field = value;
      this.getData();
    },
    getData() {
      this.loading = true;
      this.data = [];
      let url =
        this.httpsBasic.url +
        this.httpsBasic.clean +
        "Account_config/accountConfigList";
      axios
        .post(url, {
          current_page: this.page,
          per_page: 10,
          query_field: this.nameSearch,
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.data = res.data.data.data;
            // console.log(this.data);
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    edit(detail) {
      this.hideInUserEdit = true;
      this.editDetail = detail;
    },
    detailPage(detail) {
      this.hideIsWorker = true;
      this.detail = detail;
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
</style>
<style lang="less">
.ant-table {
  min-height: 58vh;
}
</style>
